<template>
    <el-dialog
        title="作品审核"
        :visible.sync="workMessExamine"
        width="1000px" :close-on-click-modal="false">
        <div class="examine">
          <h2>报名信息</h2>
          <div class="examineList">
            <p>报名时间 :</p>
            <p>{{ sign.createTime }}</p>
          </div>
          <div class="examineList examineListTwo">
            <div class="examineListTwo_box">
              <p style="white-space:nowrap">昵&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称 :</p>
              <p>{{ sign.nickName }}</p>
            </div>
            <div class="examineListTwo_box">
              <p style="white-space:nowrap">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名 :</p>
              <p>{{ sign.name }}</p>
            </div>
          </div>

          <div class="examineList examineListTwo">
            <div class="examineListTwo_box">
              <p style="white-space:nowrap">账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号 :</p>
              <p>{{ sign.account }}</p>
            </div>
              <div class="examineListTwo_box">
                  <p style="white-space:nowrap">联系电话:</p>
                  <p>{{ sign.tel }}</p>
              </div>
          </div>
            <div class="examineList examineListTwo">
                <div class="examineListTwo_box">
                    <p>参赛主体 :</p>
                    <p>{{ sign.signTypeCn }}</p>
                </div>
            </div>

          <div class="examineList examineListTwo">
            <div class="examineListTwo_box">
              <p>单位院校 :</p>
              <p>{{ sign.teamName }}</p>
            </div>
            <div class="examineListTwo_box">
              <p>指导老师 :</p>
              <p>{{ sign.teamMember }}</p>
            </div>
          </div>
        </div>
        <div class="examine">
          <h2>作品信息</h2>
            <div class="examineList">
                <p>赛道名称 :</p>
                <p>{{ info.activityWayName }}</p>
            </div>
          <div class="examineList">
            <p>作品类别 :</p>
            <p>{{ info.typeName }}</p>
          </div>
          <div class="examineList">
            <p>作品封面 :</p>
            <img :src="info.coverUrl" alt="">
          </div>

          <div class="examineList">
            <p>作品名称 :</p>
            <p>{{ info.name }}</p>
          </div>

          <div class="examineList">
            <p>作品简介 :</p>
            <p v-html="info.summary" class="examine_html vHtmlMess"></p>
          </div>
          <!--<div class="examineList">
            <p>参赛作品 :</p>
            <p style="color: #1890FF;cursor: pointer;" @click="downloadFile(info.worksUrl)">{{ info.worksName }}</p>
          </div>-->
          <div class="examineList">
            <p>作品说明 :</p>
            <p v-html="info.description" class="examine_html vHtmlMess"></p>
          </div>
          <div class="examineList">
              <p style="white-space:nowrap">参赛作品 :</p>
              <div>
                   <el-popconfirm
                      v-if="worksFileList.length>0"
                      v-for="(item,index) in worksFileList"
                      :key="index"
                      @confirm="viewInfo(item.url,item.name)"
                      @cancel="downloadFile(item.url,item.name)"
                      confirm-button-text='预览'
                      cancel-button-text='下载'
                      icon="el-icon-info"
                      title="请选择操作"
                      width="250"
                  >
                  <!--<el-popconfirm
                      v-if="worksFileList.length>0"
                      v-for="(item,index) in worksFileList"
                      :key="index"
                      @confirm="downloadFile(item.url)"
                      confirm-button-text='下载'
                      icon="el-icon-info"
                      title="是否要下载文件"
                      width="250"
                  >-->
                      <el-button slot="reference" style="margin-right:10px;margin-bottom:10px">{{ item.name }}</el-button>
                  </el-popconfirm>
                <!--<p style="color: #1890FF;cursor: pointer;margin-right:16px;width:100%"
                  v-if="worksFileList.length>0"
                  v-for="(item,index) in worksFileList"
                  :key="index"
                  @click="viewInfo(item.url,item.name)">
                    {{ item.name }}
                </p>-->
              </div>
          </div>
        </div>
         <div class="audit" v-if="type==2">
          <h3>审核结果</h3>
          <div class="auditContent">
            <el-tag type="success" effect="dark" v-if="info.status == 'PASS'">审核已通过</el-tag>
            <el-tag type="danger" effect="dark" v-if="info.status == 'REJECT'">审核已驳回</el-tag>
            <el-tag type="warning" effect="dark" v-if="info.status == 'SUBMIT'">待审核</el-tag>
            <div class="cause" v-if="info.status == 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent" v-text="info.remark"></div>
            </div>
          </div>
        </div>
        <div class="audit" v-if="type==1">
          <h3>审核</h3>
          <div class="auditContent">
            <el-radio-group v-model="auditForm.status">
              <el-radio label="PASS">通过</el-radio>
              <el-radio label="REJECT">驳回</el-radio>
            </el-radio-group>
            <div class="cause" v-if="auditForm.status === 'REJECT'">
              <div class="causeTitle">驳回原因：</div>
              <div class="causeContent" style="width: 100%">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 5 }"
                  placeholder="请输入驳回原因"
                  v-model="auditForm.remark"
                >
                </el-input>
              </div>
            </div>
            <div class="auditEnter">
              <el-button type="primary" @click="auditSubmit(info.uuid)">确定</el-button>
            </div>
          </div>
        </div>
        <view-file-dialog ref="viewFileDialog" ></view-file-dialog>
    </el-dialog>
</template>

<script>
    import viewFileDialog from './viewFileDialog';
    import { getWorksDetail,auditWorks } from '../../../utils/interface';
    export default {
        name: "examineDialog",
        components:{
            viewFileDialog,
        },
        data() {
            return{
                loadedRatio:0,
                type:"",
                workMessExamine: false,
                auditForm: {
                    uuid:'',
                    status: '',
                    remark:'',
                },
                info:{},
                sign:{},
                worksFileList:[],
                orderRecordList:[],
                // 文件类型
                fileType:"",
            }
        },
        methods: {
            init(type,uuid) {
                this.reset();
                this.type = type;
                this.auditForm.uuid = uuid;
                this.workMessExamine = true;
                getWorksDetail(uuid).then((res)=>{
                    this.info = res.info;
                    this.sign = res.sign;
                    this.worksFileList = this.info.worksFileList;
                });
            },
            reset(){
                this.auditForm = {
                    uuid:'',
                    status: '',
                    remark:'',
                }
            },
            auditSubmit(uuid){
                this.auditForm.uuid = uuid;
                if(this.auditForm.status === ''){
                    this.$message.warning('请选择审核结果！');
                } else if(this.auditForm.status === 'REJECT' && this.auditForm.remark === ''){
                    this.$message.warning('请输入驳回原因！');
                } else {
                    auditWorks(this.auditForm).then((res)=>{
                        if(res.success) {
                            this.$message.success('审核成功！');
                            this.workMessExamine = false;
                            this.$emit("submit");
                        }
                    });
                }
            },
            downloadFile(fileUrl,fileName){
                this.open1();
                this.$refs.viewFileDialog.init("download", fileName , fileUrl);
            },
            viewInfo(fileUrl){
                let fileType = fileUrl.substr(fileUrl.lastIndexOf('.')+1).toUpperCase();
                this.$refs.viewFileDialog.init("view", fileType, fileUrl);
            },
            open1() {
                const h = this.$createElement;
                this.$notify({
                    title: '提示',
                    message: h('i', { style: 'color: teal'}, '正在准备下载资源请稍后!'),
                    duration: 12000
                });
            },
        }
    }
</script>

<style scoped lang="less">

/deep/.el-popconfirm__main {
  margin: 23px 24px 17px 24px;

}
/deep/.el-dialog__body {
  padding-top: 0;
}
.examine {
  h2 {
      font-weight: 700;
      font-size: 16px;
      color: #000;
      margin-top: 26px;
      letter-spacing: 1px;
  }
  .examineList {
    display: flex;
    // align-items: center;
    img {
      width: 300px;
      height: 150px;
    }
    p:nth-of-type(1){
      margin-right: 16px;
      width: 65px;
      flex-shrink: 0;
    }
    .examine_html {
      width: 90%;
      /deep/pre {
        white-space: pre-line !important;
      }
      /deep/img {
        max-width: 100%;
      }
    }
  }
  .examineListTwo {
    display: flex;
    align-items: center;
    .examineListTwo_box {
      display: flex;
      align-items: center;
      width: 50%;
    }
  }

}
    .audit {
      padding-bottom: 20px;
      h3 {
        font-weight: 700;
        font-size: 16px;
        color: #000;
        margin-top: 26px;
        letter-spacing: 1px;
        // border-bottom: 1px solid #ddd;
        padding-bottom: 15px;
      }
      .auditContent {
        // padding: 0 30px;
      }
      .cause {
        display: flex;
        margin-top: 20px;
        .causeTitle {
          min-width: 80px;
          color: #3a8ee6;
        }
        .causeContent {
          color: #000;
        }
      }
      .auditEnter {
        text-align: center;
        padding-top: 20px;
        button {
          width: 120px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/activeDialog/examineMessDialog.vue